module.exports = __webpack_public_path__ + "img/IMG_1055.8db50038.png";